export class AfterDropValidation {
	IsPositionValid(item, sourceIndex, sourceItems, sourceContext, targetIndex, targetItems, targetContext): boolean {
		return true;
	}
}